<style src="./Moneybox.scss" lang="scss" scoped></style>
<template lang="html">
  <div
    class="component"
    :class="{'valid-fail': !isValid}">

    <label class="label">
      <span class="caption">{{ label }}</span>

      <div class="component-container">
        <div class="icon"></div>

        <input
          type="text"
          class="component-input"
          v-model="inputValue"
          v-money="money"
          :placeholder="placeholder"
          @blur="blur"
          :autofocus="autofocus"
          v-debounce="debounce"
          @debounced="emitDebounce">

      </div>

      <span class="error-message" v-show="!isValid">{{ messageError[0] }}</span>
    </label>
  </div>
</template>

<script>
import {DebounceDirective} from '../helpers/debounce/Debounce'
import {VMoney} from 'v-money'
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin.js'

export default {
  name: 'Moneybox',
  mixins: [
    ValidationMixin
  ],
  directives: {
    debounce: DebounceDirective,
    money: VMoney
  },
  props: {
    label: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    autofocus: {
      default: false
    },
    debounce: {
      default: null
    },
    precision: {
      default: 2
    }
  },
  data () {
    return {
      inputValue: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  watch: {
    precision: {
      handler (pValue) {
        this.money.precision = pValue
      },
      immediate: true
    },
    inputValue (pValue, pOldValue) {
      if (pValue !== pOldValue) this.$emit('input', pValue)
    },
    value (pValue) {
      this.refreshValues()
    }
  },
  mounted () {
    this.refreshValues()
  },
  methods: {
    refreshValues () {
      this.inputValue = this.value
    },
    blur () {
      this.$emit('blur')
      this.runValidation()
    },
    emitDebounce () {
      this.$emit('debounce', this.inputValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/moneybox/Moneybox.vue